var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-table-loader vertical-center" }, [
    _c(
      "div",
      { staticClass: "w-30 p-2 vertical-center" },
      [
        _c("b-skeleton", {
          staticClass: "mr-2 d-none d-md-block",
          attrs: { type: "avatar", width: "2.85rem", height: "2.85rem" },
        }),
        _vm._v(" "),
        _c("b-skeleton", { attrs: { width: "40%" } }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-20 px-2 vertical-center" },
      [_c("b-skeleton", { attrs: { width: "50%" } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-20 px-2 vertical-center" },
      [_c("b-skeleton", { attrs: { width: "50%" } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-20 px-2 vertical-center" },
      [_c("b-skeleton", { attrs: { width: "45%" } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-10 px-2 d-xl-flex flex-row justify-content-end" },
      [
        _c(
          "div",
          { staticClass: "d-none d-xl-flex flex-row align-items-center" },
          [
            _c("b-skeleton", {
              staticClass: "ml-auto mr-2",
              attrs: { width: "7rem", type: "button" },
            }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "mr-3",
              attrs: { width: "6rem", type: "button" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex d-xl-none" },
          [
            _c("b-skeleton", {
              staticClass: "ml-auto mr-2",
              attrs: { width: "0.5rem" },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }